import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button, TextField} from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Loadingmini from '../components/loadingmini';
import { SelectField } from '@aws-amplify/ui-react';

const PAYMENT_TIMEZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
    'UTC',
];

function browserTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch (e) {
        return 'UTC';
    }
}

function nowLocalInputValue() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function formatPaidAt(utcValue, timeZone) {
    if (!utcValue) return '';
    const iso = String(utcValue).replace(' ', 'T');
    const withZone = iso.endsWith('Z') ? iso : `${iso}Z`;
    const date = new Date(withZone);
    if (Number.isNaN(date.getTime())) return String(utcValue);
    try {
        return new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone || 'UTC',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZoneName: 'short',
        }).format(date);
    } catch (e) {
        return String(utcValue);
    }
}

export default function Usercredits({userJwt, refreshJwt, userId, fleetCode, isAdminOrFleet}) {
    const [is_loading, updateIsLoading] = React.useState(false);
    const [display_form, updateDisplayForm] = React.useState(false);
    const [count, setCount] = useState(0);
    const [credits, setCredits] = useState(0);
    const [res_id, setResId] = useState("");
    const [source, setSource] = useState("");
    const [notes, setNotes] = useState("");
    const [paidAtLocal, setPaidAtLocal] = useState("");
    const [paidTimezone, setPaidTimezone] = useState(browserTimeZone);
    const [credits_to_grant, setCreditsToGrant] = useState(0);
    const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",rows:[]})
    const [canIssueCredits, updateCanIssueCredits] = React.useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const SOURCE_OPTIONS = [
        'other',
        'cash payment - cash',
        'cash payment - cashapp',
        'cash payment - chime',
        'cash payment - zelle',
        'cash payment - apple pay',
        'cash payment - google pay',
        'cash payment - clover',
        'cash payment - other',
        'customer reimbursement credit',
        'loyalty credit',
        'tolls'
      ];
    const columns = [
        {
            headerName: 'Datetime',
            field: 'created',
            filter: true
        },
        {
            headerName: 'Entry Type',
            field: 'entry_type',
            filter: true
        },
        {
            headerName: 'Amount',
            field: 'amount',
            filter: true
        },
        {
            headerName: 'Shift',
            field: 'shift',
            filter: true
        },
        {
            headerName: 'Source',
            field: 'source',
            filter: true
        },
        {
            headerName: 'Payment time',
            field: 'paid_at_utc',
            filter: true,
            valueGetter: (params) => formatPaidAt(params.data?.paid_at_utc, params.data?.paid_timezone),
        },
        {
            headerName: 'Notes',
            field: 'notes',
            filter: true
        },
        {
            headerName: 'UserID',
            field: 'user_id',
            filter: true
        },
        {
            headerName: 'Name',
            field: 'name_full',
            filter: true
        },
        {
            headerName: 'FleetID',
            field: 'fleet_id',
            filter: true
        }
  ];
  

  async function fetchPageData() {
    if(userId > 0)
    {
        updateRes({status:"loading...",rows:[]})
        updateIsLoading(true)
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": userJwt,
            "api_endpoint":"api3:portal:driver_desk",
            "section":"credits",
            "request_type":"GET",
            "driver_id":userId,
            "fleet_code":fleetCode
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            var new_credits = 0
            res.rows.forEach(item => {
                try {
                    var credits_to_add = Number(item['amount'])
                    if (Number.isFinite(credits_to_add)) {
                        new_credits = new_credits + credits_to_add
                    }
                }
                catch (e) {
                    console.log('drivercredits error sum credits: '+toString(e));
                    updateIsLoading(false)
                }
            })
            setCredits(Math.round(new_credits * 100) / 100)
            //console.log('drivercredits user ' + userId + ' : ' + JSON.stringify(res))
            updateRes(res)
            if('detail' in res)
            {
                if(res['detail'].includes("token"))
                {
                    refreshJwt()
                }
            }
            if('can_grant_credits' in res)
            {
                if(res['can_grant_credits'] > 0)
                {
                    updateCanIssueCredits(true)
                }
            }
            updateIsLoading(false)
        }
        catch (e) {
            console.log('drivercredits error: '+toString(e));
            if (e?.response?.status === 401) {
                refreshJwt();
            }
            updateIsLoading(false)
        }
        updateIsLoading(false)
    }
  }

  async function grantCredits() {
    if(userId > 0)
    {
        updateIsLoading(true)
        setErrorMsg("");
        if (!fleetCode || String(fleetCode).trim() === "") {
            setErrorMsg("Select the reservation's fleet in the sidebar (fleets=) before granting credits. Credits are fleet-scoped.");
            updateIsLoading(false)
            return;
        }
        var t_credits_to_grant = parseInt(credits_to_grant)
        // source is required
        if (!source || source.trim() === "") {
            setErrorMsg("Please select a source.");
            updateIsLoading(false)
            return;
        }
        // notes required when source is 'other'
        if (source === "other" && (!notes || notes.trim() === "")) {
            setErrorMsg("Please enter a note when source is 'other'.");
            updateIsLoading(false)
            return;
        }
        const isCashPayment = source.startsWith("cash payment");
        if (isCashPayment && (!paidAtLocal || !paidTimezone)) {
            setErrorMsg("Enter the payment time and timezone.");
            updateIsLoading(false)
            return;
        }
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": userJwt,
            "api_endpoint":"api3:portal:driver_desk",
            "section":"credits",
            "request_type":"POST",
            "driver_id":userId,
            "credits_to_grant":t_credits_to_grant,
            "res_id":res_id,
            "source":source,
            "notes":notes,
            "fleet_code":fleetCode,
            ...(isCashPayment ? {
                "paid_at_local": paidAtLocal,
                "paid_timezone": paidTimezone,
            } : {}),
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log('drivercreditsgrantcredits user ' + userId + ' : ' + JSON.stringify(res))
            if (typeof res === 'string' && /error|inconsistent|invalid/i.test(res)) {
                setErrorMsg(res);
                updateIsLoading(false);
            } else if (res && typeof res === 'object' && ('detail' in res)) {
                setErrorMsg(res['detail'] || "Something went wrong");
                updateIsLoading(false);
            } else if (res && typeof res === 'object' && typeof res.status === 'string' && /error|inconsistent/i.test(res.status)) {
                setErrorMsg(res.status);
                updateIsLoading(false);
            } else {
                setNotes("");
                setSource("");
                setPaidAtLocal("");
                setPaidTimezone(browserTimeZone());
                setResId("");
                setCreditsToGrant(0);
                setErrorMsg(""); // clear old errors
                setCount(count + 1)
            }
        }
        catch (e) {
            console.log('drivercredits error: '+e);
            const detail = e?.response?.data?.detail || e?.response?.data?.status || e?.message;
            setErrorMsg(detail ? String(detail) : "Request failed. Please try again.");
            updateIsLoading(false)
        }
        updateIsLoading(false)
    }
  }

  useEffect(() => {
    fetchPageData()
    },[count, userId, userJwt, fleetCode])



  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Divider />
            {
                is_loading ? <Loadingmini /> : 
                <Flex 
                    direction='column'
                >
                    <Heading level={2}>Driver Credits</Heading>
                    <Text style={{width:'100%'}}>This is the history of credits issued to and removed from the driver.</Text>
                    <Text style={{width:'100%', fontWeight: 'bold'}}>
                      Active fleet for credits: {fleetCode ? fleetCode : '(none selected — set fleets= in the URL to the reservation fleet, e.g. BIBC)'}
                    </Text>
                    {res.credit_user_mismatch ? (
                      <Text style={{ color: '#b00020', width: '100%' }}>
                        {res.credit_user_message || 'This user is not a member of the selected fleet. Credits are per user and fleet.'}
                        {res.suggested_driver_id ? (
                          <>
                            {' '}
                            <NavLink
                              to={`/user/${res.suggested_driver_id}${fleetCode ? `?fleets=${encodeURIComponent(fleetCode)}` : ''}`}
                            >
                              Open user {res.suggested_driver_id}
                            </NavLink>
                          </>
                        ) : null}
                      </Text>
                    ) : null}
                    {!fleetCode ? (
                      <Text style={{ color: '#b00020', width: '100%' }}>
                        Credits are fleet-scoped. Granting while the wrong fleet is selected (e.g. FORE while the rental is BIBC) will not apply to that reservation.
                      </Text>
                    ) : null}
                    <View>
                        <Button onClick={() => setCount(count + 1)}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
                    <Heading level={4}>Total credits:  {credits}</Heading>
                    <View style={{width:"100%"}}>
                        <View 
                            theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                            style={{ height: 500 }} // the grid will fill the size of the parent container
                        >
                                <AgGridReact
                                    rowData={res.rows}
                                    columnDefs={columns}
                                    rowSelection={multiRowSelection}
                                    paginationPageSize={500}
                                    paginationPageSizeSelector={[10, 25, 50]}
                                    enableCellTextSelection={true}
                                />
                        </View>
                    </View>
                    
                        { //isAdminOrFleet === false ? undefined :
                            canIssueCredits === false || res.credit_user_mismatch ? undefined :
                            display_form === false ? 
                                <Flex direction="column" gap="1rem" >
                                    <Button onClick={() => updateDisplayForm(true)}>GRANT OR REMOVE CREDITS</Button>
                                </Flex>
                            : 
                                <Flex direction="column" gap="1rem" >
                                    <Heading level={2}>Driver Credits</Heading>
                                    <Text>Grant this user credits toward reservations. Enter a negative number to remove credits.</Text>
                                    <Text style={{ fontWeight: 'bold' }}>
                                      Granting against fleet: {fleetCode || '(none)'}
                                    </Text>
                                    <Text>
                                      If you enter a reservation ID, it must belong to this same fleet or the server will reject the grant.
                                    </Text>
                                    <TextField 
                                        placeholder='credits to grant or remove'
                                        value={credits_to_grant}
                                        onInput={(e) => setCreditsToGrant(e.target.value)} />
                                    <SelectField
                                        label="Source"
                                        placeholder="Select source"
                                        value={source}
                                        onChange={(e) => {
                                            const next = e.target.value;
                                            setSource(next);
                                            if (next.startsWith("cash payment")) {
                                                setPaidAtLocal((prev) => prev || nowLocalInputValue());
                                                setPaidTimezone((prev) => prev || browserTimeZone());
                                            }
                                        }}
                                    >
                                        {SOURCE_OPTIONS.map((opt) => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </SelectField>
                                    {source === "other" && !notes && (
                                        <Text style={{ color: "#b00020", marginTop: "4px" }}>
                                            Please include a note when selecting "other" to specify the source.
                                        </Text>
                                    )}
                                    {source.startsWith("cash payment") && (
                                        <>
                                            <TextField
                                                label="Payment time"
                                                type="datetime-local"
                                                value={paidAtLocal}
                                                onInput={(e) => setPaidAtLocal(e.target.value)}
                                            />
                                            <SelectField
                                                label="Payment timezone"
                                                value={PAYMENT_TIMEZONES.includes(paidTimezone) ? paidTimezone : browserTimeZone()}
                                                onChange={(e) => setPaidTimezone(e.target.value)}
                                            >
                                                {!PAYMENT_TIMEZONES.includes(browserTimeZone()) && (
                                                    <option value={browserTimeZone()}>{browserTimeZone()}</option>
                                                )}
                                                {PAYMENT_TIMEZONES.map((zone) => (
                                                    <option key={zone} value={zone}>{zone}</option>
                                                ))}
                                            </SelectField>
                                            <Text>
                                                Defaults to now on this computer. The clock time is the wall time in the timezone you pick, and we store that instant in UTC.
                                            </Text>
                                        </>
                                    )}
                                    <TextField
                                        placeholder="notes on source or reason for credits"
                                        value={notes}
                                        onInput={(e) => setNotes(e.target.value)}
                                    />
                                    <TextField
                                        placeholder='reservation ID (if applicable — must match fleet above)'
                                        value={res_id}
                                        onInput={(e) => setResId(e.target.value)}
                                    ></TextField>
                                    {errorMsg ? (
                                        <View
                                            style={{
                                                backgroundColor: "#ffe5e5",
                                                border: "1px solid #ff4d4f",
                                                padding: "10px",
                                                borderRadius: "8px",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Text style={{ color: "#b00020" }}>
                                                {errorMsg}
                                            </Text>

                                            <Button
                                                size="small"
                                                onClick={() => setErrorMsg("")}
                                            >
                                                ✕
                                            </Button>
                                        </View>
                                    ) : null}
                                    <Button onClick={() => grantCredits()}>SUBMIT</Button>
                                    <br/>
                                    <Button onClick={() => updateDisplayForm(false)}>HIDE FORM</Button>
                                </Flex>
                        }
                    <Divider />
                </Flex>
            }
        </View>
      </Flex>
  );
}
